export const weekNumIncrease = ({
  curYear,
  weekNumber,
  weeksOffset,
}: {
  curYear: number;
  weekNumber: number;
  weeksOffset: number;
}) => {
  return weekNumber;

  // if (weeksOffset > 0) {
  //   return weekNumber;
  // }

  // if (curYear === 2025 && weekNumber === 52) {
  //   return 1;
  // }

  if (weeksOffset === 0) {
    if (weekNumber === 1) {
      return 53;
    }

    if (curYear === 2024) {
      return weekNumber;
    }
  }

  // if (curYear === 2024) {
  //   return weekNumber;
  // }

  // return weekNumber - 1

  // if (weeksOffset === 1) {
  //   if (weekNumber === 2) {
  //     return 1;
  //   }

  //   if (weekNumber === 3) {
  //     return 2;
  //   }
  // }

  if (weeksOffset === 1) {
    if (weekNumber === 1) {
      return 53;
    }
    if (weekNumber === 2 && curYear === 2024) {
      return 1;
    }
    if (curYear === 2025) {
      return weekNumber - 1;
    }
  }

  return weekNumber - 1 + weeksOffset;
};

export const _53_WeekNumberYearFix = ({
  year,
  week,
  weeksOffset,
}: {
  year: number;
  week: number;
  weeksOffset: number;
}) => {
  return { week, year };
  week = weekNumIncrease({
    curYear: year,
    weekNumber: week,
    weeksOffset,
  });

  if (week === 53 && year === 2025) {
    year = 2024;
  }
  if (week === 52 && year === 2026) {
    year = 2025;
  }
  if (week === 1 && year === 2024) {
    year = 2025;
  }

  return { year, week };
};

export const _53_WeekNumberYearFix_1_week_shift = ({
  year,
  week,
  weeksOffset,
}: {
  year: number;
  week: number;
  weeksOffset: number;
}) => {
  // console.log({ year, week, weeksOffset });
  return {
    year,
    week,
  };
  const modifiedDate = _53_WeekNumberYearFix({ year, week, weeksOffset });

  let newYear = modifiedDate.year;
  let newWeek = modifiedDate.week + 1;

  if (newWeek === 54) {
    newYear = year;
    newWeek = 1;
  }

  return { year: newYear, week: newWeek };
};

export const substituteWeekNumberInFormattedString = (
  formattedData: string,
  weeksOffset: number
) => {
  // console.log(formattedData, weeksOffset);
  if (typeof formattedData !== 'string') {
    return formattedData;
  }

  if (!formattedData.match(/Week/)) {
    return formattedData;
  }

  const [_, curWeek, curYear] = formattedData.match(
    /\bWeek\s+(\d{1,2}),\s+(\d{4})\b/
  )!;

  let year = parseInt(curYear);
  let week = parseInt(curWeek);

  const { year: newYear, week: newWeek } = _53_WeekNumberYearFix({
    year,
    week,
    weeksOffset,
  });

  year = newYear;
  week = newWeek;
  return formattedData.replace(
    /\bWeek\s+(\d{1,2}),\s+(\d{4})\b/,
    `Week ${week}, ${year}`
  );
};
